import { ReactNode } from 'react';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import {
  Card,
  Table,
  Text,
  styled,
  useMediaQuery,
  useTheme,
} from '@/theme/index';

export interface VehicleSectionProps {
  headers: (string | JSX.Element)[];
  tableData: (string | JSX.Element)[][];
  mobileTableData: JSX.Element[];
  reportSectionTitle: string;
  sectionId: string;
  preTitleIcon?: ReactNode | null;
  customTitleStyle?: object;
  bodyRowStyle?: object;
  tableTitle?: string;
  children?: React.ReactNode;
  howItWorks?: JSX.Element;
  emptySectionTitle: string;
}

export const StyledCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(1),
  padding: theme.spacing(2.5),

  [theme.breakpoints.down('sm')]: {
    border: 'none',
    borderRadius: 0,
    boxShadow: 0,
    padding: 0,
  },
}));

export const VehicleSection: React.FC<VehicleSectionProps> = ({
  headers,
  tableData,
  mobileTableData,
  preTitleIcon,
  reportSectionTitle,
  customTitleStyle,
  sectionId,
  tableTitle,
  children,
  howItWorks,
  emptySectionTitle,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <ReportSection
      title={reportSectionTitle}
      showTopBar
      customTitleStyle={customTitleStyle}
      preTitleIcon={preTitleIcon}
      hasContent={tableData?.length > 0}
      sectionId={sectionId}
      howItWorks={howItWorks}
      customEmptyText={
        <EmptyVehicleSectionDisclaimer title={emptySectionTitle} />
      }
    >
      <StyledCard variant="outlined">
        {tableTitle && <Text variant="h3">{tableTitle}</Text>}
        {tableData?.length && !isMobile && (
          <Table
            sectionId={`${sectionId}-table`}
            className="styleless-header striped"
            headers={headers}
            rows={tableData}
            sx={{
              '.MuiTableCell-root': {
                p: 0,
              },
            }}
          />
        )}
        {tableData?.length && isMobile && mobileTableData}
        {children}
      </StyledCard>
    </ReportSection>
  );
};
